import MaterialTable, { MTableEditRow } from "@material-table/core";

import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import { ExportCsv } from "@material-table/exporters";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import { forwardRef } from "react";
import { makeStyles } from "@material-ui/core";
import useLocale from "../../hooks/useLocale";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const useStyles = makeStyles({
  deleteRow: {
    "& td": {
      textAlign: "center",
    },
  },
});

const CustomTable = ({ options, ...props }, ref) => {
  const classes = useStyles();
  const { t } = useLocale();
  return (
    <MaterialTable
      tableRef={ref}
      icons={tableIcons}
      {...props}
      components={{
        EditRow: (props) => (
          <MTableEditRow className={classes.deleteRow} {...props} />
        ),
      }}
      options={{
        actionsColumnIndex: -1,
        exportMenu: [
          //   {
          //   label: t('Export as PDF'),
          //   //// You can do whatever you wish in this function. We provide the
          //   //// raw table columns and table data for you to modify, if needed.
          //   // exportFunc: (cols, datas) => console log({ cols, datas })
          //   exportFunc: (cols, datas) => ExportPdf(cols, datas, props.filename || 'csvdata')
          // },
          {
            label: t("Export as CSV"),
            exportFunc: (cols, datas) =>
              ExportCsv(cols, datas, props.filename || "pdfData"),
          },
        ],
        exportAllData: true,
        columnsButton: true,
        loadingType: "linear",
        // searchAutoFocus: true,
        addRowPosition: "first",
        showTitle: false,
        searchFieldAlignment: "right",
        toolbarButtonAlignment: "right",
        ...options,
      }}
      localization={{
        body: {
          emptyDataSourceMessage: t("No records to display"),
          addTooltip: t("Add"),
          deleteTooltip: t("Delete"),
          editTooltip: t("Edit"),
          filterRow: {
            filterTooltip: t("Filter"),
          },
          editRow: {
            deleteText: t("Are you sure you want to delete this row?"),
            cancelTooltip: t("Cancel"),
            saveTooltip: t("Save"),
          },
        },
        grouping: {
          placeholder: `${t("Drag headers")}...`,
          groupedBy: `${t("Grouped by")}:`,
        },
        header: {
          actions: t("Actions"),
        },
        pagination: {
          labelDisplayedRows: `{from}-{to} ${t("of")} {count}`,
          labelRowsSelect: t("rows"),
          labelRowsPerPage: `${t("Rows per page")}:`,
          firstAriaLabel: t("First Page"),
          firstTooltip: t("First Page"),
          previousAriaLabel: t("Previous Page"),
          previousTooltip: t("Previous Page"),
          nextAriaLabel: t("Next Page"),
          nextTooltip: t("Next Page"),
          lastAriaLabel: t("Last Page"),
          lastTooltip: t("Last Page"),
        },
        toolbar: {
          addRemoveColumns: t("Add or remove columns"),
          nRowsSelected: `{0} ${"selected rows"}`,
          showColumnsTitle: t("Show Columns"),
          showColumnsAriaLabel: t("Voir les colonnes"),
          exportTitle: t("Export"),
          exportAriaLabel: t("Export"),
          exportCSVName: t("Export as CSV"),
          searchTooltip: t("Search"),
          searchPlaceholder: t("Search"),
        },
      }}
    />
  );
};

export default forwardRef(CustomTable);
